import React from "react";
import { useSelector } from "react-redux";
import { getAutoClassificationEnabled } from "selectors/Intelligence";
import ActionMenu, { LinkAction } from "widgets/ActionMenu";
import { VERSIONS_PREVIEW_ACTIONS } from "widgets/grid/cells/VersionActionLists/PreviewActions";
import EllipsisActions from "widgets/grid/cells/VersionActionLists/EllipsisActions";
import Permissioned from "widgets/Permissioned";

import { getPreviewVersion2 } from "utils/Flags";
import {
	isMaxDynamicSocialVersions,
	isSocialCreative,
	isVideoBuilderCreative
} from "utils/common";

import './CreativeActions.css';

const VERSION_DOMAIN = "Version Library";

function VersionActions({ dependentValues }) {
	let { versionId } = dependentValues
		, libraryId = useSelector(state=>(state.libraryProperties.id))
		, user = useSelector(state => state.you)
		, version = useSelector(state => state.creativeVersions?.items?.find(item => item.id === versionId) || {})
		, totalItems =  useSelector(state => state.creativeVersions.totalItems)
		, creative = useSelector(state => state.creativeDetails)
		, isAutoClassificationEnabled = useSelector(getAutoClassificationEnabled)
		, isVideoBuilder = isVideoBuilderCreative(creative)
		;

	// ***** Link Action Props ***** //
	const commonLinkActionProps={
		useMenuItem:false,
		iconClass:"bounce-circle",
	};

	let actionMenuProps = {
		preview: {
			icon:"far fa-eye",
			actionLists:[VERSIONS_PREVIEW_ACTIONS],
			actionContext:{ libraryId, dependentValues },
			tooltipContent: "Preview",
		},
	};

	let linkActionProps = {
		duplicate:{
			...commonLinkActionProps,
			isDisabled: isMaxDynamicSocialVersions(totalItems, creative) || isVideoBuilder,
			iconName:"duplicate",
			iconStyle:"far",
			tooltipContent:"Duplicate",
			path:`/library/${libraryId}/creative/${dependentValues.creativeId}/versions/${dependentValues.versionId}/modal/duplicate-version/`,
		},
		editVersion:{
			...commonLinkActionProps,
			isDisabled: isVideoBuilder,
			iconName:"edit",
			tooltipContent:"Edit Version",
			path:`/library/${libraryId}/creative/${dependentValues.creativeId}/versions/${dependentValues.versionId}/modal/edit-version/`,
		},
	};

	let $ellipsisActions = (
		<EllipsisActions
			key = "version-ellipsis-actions"
			user = {user}
			libraryId = {libraryId}
			creative = {creative}
			version = {version}
			isAutoClassificationEnabled = {isAutoClassificationEnabled}
		/>
	);

	let $preview =  <ActionMenu key="preview-version" {...actionMenuProps.preview}  />
		, $duplicate = (
			<Permissioned
				domain = {VERSION_DOMAIN}
				action = "Duplicate version"
				key={`duplicate-version-${versionId}`}
			>
				<LinkAction {...linkActionProps.duplicate} />
			</Permissioned>
		)
		, $editVersion = (
			<Permissioned
				domain = {VERSION_DOMAIN}
				action = "Edit version"
				key={`edit-version-${versionId}`}
			>
				<LinkAction {...linkActionProps.editVersion} />
			</Permissioned>
		)
		, actionList = [
			$preview,
			$editVersion,
			$duplicate,
			$ellipsisActions,
		];

	if(getPreviewVersion2()){
		let linkProps = {
			...commonLinkActionProps,
			iconName:"far fa-money-check-pen",
			tooltipContent:"Experimental Edit Version",
			path:`/library/${libraryId}/creative/${dependentValues.creativeId}/versions/${dependentValues.versionId}/modal/refined-edit-version/`,
		};

		if(isSocialCreative(creative)){
			linkProps.path = `/library/${libraryId}/creative/${dependentValues.creativeId}/versions/${dependentValues.versionId}/modal/edit-version2/`;
		}

		actionList = [
			$preview,
			$editVersion,
			(
				<Permissioned
					domain = {VERSION_DOMAIN}
					action = "Edit version"
					key={`edit-version2-${versionId}`}
				>
					<LinkAction {...linkProps} />
				</Permissioned>
			),
			$duplicate,
			$ellipsisActions,
		];
	}	//end if(getPreviewVersion2())


	return (
		<div className="flex-center grid-actions" >{actionList}</div>
	);
}

function getVersionMetadata(data) {
	return {
		creativeId: data.creativeId,
		versionId: data.id,
		versionName: data.name,
	};
}

export default {
	key: 'version-actions',
	name: 'Actions',
	cellClass: 'actions-cell',
	width: 150,
	formatter: VersionActions,
	resizable: false,
	sortable: false,
	locked: true,
	getRowMetaData: getVersionMetadata,
};
